<form [formGroup]="form" [exitConfirmation]="form" class="d-flex flex-row">
    <edl-floating-label-container label="Template Type" for="templateTypeTitle"   class="flex-grow-1 me-2">
        <input type="text" id="templateTypeTitle" formControlName="Title" class="form-control" name="Template Type" />
    </edl-floating-label-container>
    <button *ngIf="form.get('CanModify')?.value" type="button" (click)="save()" [ladda]="busy" [disabled]="form.disabled || form.invalid || form.pristine" class="btn btn-secondary me-2 save-button" aria-label="Save template type">
        <i class="far fa-save" aria-hidden="true"></i>
    </button>
    <button *ngIf="form.get('CanModify')?.value"  type="button" (click)="delete()" [ladda]="busy" [disabled]="form.disabled" class="btn btn-danger" aria-label="Delete template type">
        <i class="fas fa-trash-alt" aria-hidden="true"></i>
    </button>
</form>
